import { takeLatest, call, put } from "redux-saga/effects";
import { sagaPromise } from "../../helpers/saga-promise-helpers";

import userReportsService from "../../services/userReportsService";
import {
    searchUserReportsAction,
    getUserReportDetailsAction,
} from "../reducers/userReportsReducer";

import { alertTypes } from "../constants";

function* searchUserReportsWorker(action) {
    try {
        const { data, error } = yield call(
            userReportsService.searchUserReport,
            action.payload?.params
        );
        if (error) {
            yield put(searchUserReportsAction.error(error));
        } else {
            yield put(searchUserReportsAction.success({ ...action, data }));
        }
    } catch (err) {
        yield put(searchUserReportsAction.error(err));
    }
}

function* getUserReportDetailsWorker(action) {
    const { data, error } = yield call(
        userReportsService.getUserReportDetails,
        action.payload?.params
      );
      if (error) {
        if (error.headers["x-message-info"]) {
          yield put({
            type: alertTypes.ERROR,
            message: error.headers["x-message-info"],
          });
          throw new Error(error.headers["x-message-info"]);
        }
      }
      return data;
}

function* userReportsSaga() {
    yield takeLatest(
        searchUserReportsAction.start,
        searchUserReportsAction.waiterActionForSaga(sagaPromise(searchUserReportsWorker))
    );
    yield takeLatest(
        getUserReportDetailsAction.start,
        getUserReportDetailsAction.waiterActionForSaga(sagaPromise(getUserReportDetailsWorker))
    );
}

export default userReportsSaga;
